<template>
  <div>
    <b-card>
      <div class="d-flex px-0 flex-wrap mb-1 align-items-center">
        <!-- <b-form-group label="فیلتر بر اساس" class="col-lg-3 pr-md-2 px-0 mb-2"> -->
        <!-- <select-box
            v-model="selectedTypes"
            label="text"
            class="w-100"
            :lists="types"
            multiple
          />
        </b-form-group> -->
        <b-form-group label="کاربر" class="mb-1 col-lg-3 pr-md-2 px-0">
          <select-box
            v-model="selectedItems['user_id']"
            label="text"
            class="w-100"
            select="id"
            url="user"
            searchable
          />
        </b-form-group>
        <b-form-group label="فیلتر بر اساس" class="mb-1 col-lg-3 pr-md-2 px-0">
          <select-box
            v-model="selectedItems['auditable_type']"
            label="text"
            class="w-100"
            select="val"
            :lists="types"
            searchable
          />
        </b-form-group>
        <b-form-group
          v-if="selectedItems['auditable_type']"
          class="mb-1 col-lg-3 pr-md-2 px-0"
          label="انتخاب شناسه"
        >
          <select-box
            v-model="selectedItems['auditable_id']"
            label="text"
            class="w-100"
            select="id"
            :url="selectedItems['auditable_type']"
            searchable
          />
        </b-form-group>
      </div>

      <data-table :fields="fields" :items="auditLogs" :loading="loading">
        <template #id="{ data }">
          {{ data.item.id }}
        </template>
        <template #user="{ data }">
          {{ data.item.user.first_name + " " + data.item.user.last_name }}
        </template>
        <template #auditable_type="{ data }">
          {{ convertLogs(data.item.auditable_type) }}
        </template>
        <template #old_values="{ data }">
          <div v-if="Object.keys(data.item.old_values).length" class="c-table">
            <div
              v-for="(val, key, index) in data.item.old_values"
              :key="index"
              class="my-50"
            >
              <span style="white-space: nowrap" v-if="key != 'response'">{{
                convertLogs(key, val)
              }}</span>
              <template v-else>
                <span>جواب :</span>
                <span v-html="val"></span>
              </template>
            </div>
          </div>
          <div v-else>-</div>
        </template>
        <template #new_values="{ data }">
          <div v-if="Object.keys(data.item.new_values).length" class="c-table">
            <div
              v-for="(val, key, index) in data.item.new_values"
              :key="index"
              class="my-50"
            >
              <span style="white-space: nowrap" v-if="key != 'response'">{{
                convertLogs(key, val)
              }}</span>
              <template v-else>
                <span>جواب :</span>
                <span v-html="val"></span>
              </template>
            </div>
          </div>
          <div v-else>-</div>
        </template>
        <template #event="{ data }">
          {{ convertLogs(data.item.event) || "-" }}
        </template>
        <template #created_at="{ data }">
          {{ calcDate(data.item.created_at) || "-" }}
        </template>
        <template #Ip="{ data }">
          {{ data.item.ip_address || "-" }}
        </template>
      </data-table>

      <div
        class="w-100 d-flex flex-wrap justify-content-between align-items-center"
      >
        <div
          class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="pagination.per_page"
            size="md"
            class="my-2 d-flex justify-content-center"
          ></b-pagination>
        </div>
        <b-form
          @submit.prevent="goTo"
          class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
        >
          <div>
            <b-button type="submit" size="sm" variant="primary"
              >رفتن به
            </b-button>
          </div>
          <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
            <b-form-input
              id="to-page"
              type="number"
              size="sm"
              :max="pagination.total_pages"
              min="1"
              v-model="choosenPage"
            />
          </b-form-group>
        </b-form>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BButton,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormInput,
  BForm,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import auditLogs from "./auditKeys";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BCard,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormInput,
    BForm,
    BFormGroup,
    SelectBox,
  },

  data() {
    return {
      choosenPage: 1,

      types: [
        {
          id: 1,
          text: "ترم",
          val: "semester",
        },
        {
          id: 2,
          text: "دوره",
          val: "course",
        },
        {
          id: 3,
          text: "جلسه",
          val: "session",
        },
        {
          id: 4,
          text: "تمرین",
          val: "exercise",
        },
        {
          id: 5,
          text: "رویداد",
          val: "event",
        },
        // {
        //   id: 6,
        //   text: "فاکتور",
        //   val: "invoice",
        // },
        // {
        //   id: 7,
        //   text: "جریمه",
        //   val: "penalty",
        // },
        // {
        //   id: 8,
        //   text: "تراکنش",
        //   val: "transactrion",
        // },
        // {
        //   id: 9,
        //   text: "نظر",
        //   val: "comment",
        // },
      ],
      selectedItems: {
        auditable_type: "",
        auditable_id: "",
      },
      auditLogs: [],
      loading: false,
      url: "/panel/audits",
      currentPage: 1,
      pagination: {},
      visible: false,
      loader: false,
      fields: [
        { key: "id", label: "شناسه" },
        { key: "user", label: "نام کاربر" },
        { key: "auditable_type", label: "مدل" },
        { key: "old_values", label: "مقدار قبلی" },
        { key: "new_values", label: "مقدار جدید" },
        { key: "event", label: "عملیات" },
        { key: "created_at", label: "تاریخ" },
        { key: "Ip", label: "Ip" },
      ],
    };
  },
  created() {
    if (Object.keys(this.$route.query).length) {
      this.$router
        .push({
          name: "audit-logs",
          query: {
            page: this.$route.query.page,
          },
        })
        .catch(() => {});
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.getAuditLogs();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router
          .push({
            name: "audit-logs",
            query: {
              ...this.$route.query,
              page: val,
            },
          })
          .catch(() => {});
      }
    },
    selectedItems: {
      async handler(newVal, oldVal) {
        if (newVal.auditable_type == null) {
          newVal.auditable_id = "";
        }
        if (Object.keys(newVal).length) {
          let filters = {
            auditable: {},
          };
          Object.keys(newVal).map((key) => {
            if (newVal[key]) {
              if (key == "user_id" && newVal[key])
                filters.user_id = newVal[key];

              if (key == "auditable_type" && newVal[key])
                filters.auditable.type = newVal[key];

              if (key == "auditable_id" && newVal[key])
                filters.auditable.id = newVal[key];
            }
          });
          if (
            filters.user_id ||
            (!filters.user_id && filters.auditable.id) ||
            (filters.user_id && filters.auditable.type && filters.auditable.id)
          ) {
            this.$router
              .push({
                name: "audit-logs",
                query: {
                  filters,
                },
              })
              .catch(() => {});
          } else {
            this.$router
              .push({
                name: "audit-logs",
              })
              .catch(() => {});
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    convertLogs(key, val) {
      return val != null
        ? auditLogs[key] +
            " : " +
            (val == 1 && key == "status"
              ? "فعال"
              : val == 0 && key == "status"
              ? "غیر فعال"
              : val == 1 && key == "gender"
              ? "مرد"
              : val == 0 && key == "gender"
              ? "زن"
              : val == 1
              ? "بله"
              : val == 0
              ? "خیر"
              : key.includes("_at")
              ? this.calcDate(val)
              : val)
        : auditLogs[key];
    },
    async getAuditLogs() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          includes: ["user", "auditable"],
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.auditLogs = data.data.audits;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="scss">
.c-table {
  overflow: auto;
  max-width: 20vw;
  /* width */
  &::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #e2e2e2;
    border-radius: 10px;
  }
}
</style>
